import { useState, useEffect } from "react";
import { stateTitleObj } from "@/helpers/constant/content_data";
import { Fragment } from "react";
import StateBadge from "./stage-badge/stage_badge";
import style from "./new_guide.module.css";

// new designed guide according to current new ui
export default function NewGuide({
  state = 0,
  stateTitles = stateTitleObj,
}) {
  // Todo find better way to handle in local development
  // - branch checkout content data wil not load issue
  const [guideStateTitles] = useState(stateTitles)
  const [stateTitleLoaded, setStateTitleLoaded] = useState(false)

  useEffect(() => {
    if(guideStateTitles) setStateTitleLoaded(true)
  }, [guideStateTitles])

  return (
    <div className={style.purchase_state_wrapper}>
      <ul className={style.purchase_state_list}>
        { stateTitleLoaded &&
            guideStateTitles.map((titleObj, key) => (
              <Fragment key={key}>
                <StateBadge
                  titleObj={titleObj}
                  currentState={state}
                />
              </Fragment>
            )
          )
        }
      </ul>
    </div>
  );
}
